import React, { ReactNode } from 'react';
import styles from '../../../pages/authorized/warranty-request/WarrantyRequestModal.module.scss';
import clsx from 'clsx';
import { Button, ButtonColor } from '../buttons/Button.tsx';
import { Modal } from './Modal.tsx';

type OwnProps = {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  submitButtonText: string;
  cancelButtonText: string;
  titleText: string;
  submitButtonType?: ButtonColor;
  cancelButtonType?: ButtonColor;
  containerClassName?: string;
  contentClassName?: string;
  children?: ReactNode;
  onClose?: () => void;
  bodyText?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  doNotCloseOnOutsideClick?: boolean;
  formSubmitErrorText?: string;
  submitButtonTestId?: string;
  cancelButtonTestId?: string;
  textClassName?: string;
  buttonContainerClassName?: string;
  hideButtons?: boolean;
  titleAdditionalContent?: ReactNode;
};

export const CustomModal = (props: OwnProps) => {
  const {
    bodyText,
    onSubmit,
    onClose,
    isOpen,
    onCancel,
    submitButtonText,
    cancelButtonText,
    children,
    titleText,
    containerClassName,
    contentClassName,
    submitButtonType,
    cancelButtonType,
    isDisabled,
    isLoading,
    doNotCloseOnOutsideClick,
    formSubmitErrorText,
    submitButtonTestId,
    cancelButtonTestId,
    textClassName,
    buttonContainerClassName,
    hideButtons,
    titleAdditionalContent,
  } = props;

  const submitButtonColor = submitButtonType ?? ButtonColor.Warning;
  const cancelButtonColor = cancelButtonType ?? ButtonColor.Secondary;

  return (
    <Modal
      containerClassName={clsx(styles.modalBodyMinWidth540, containerClassName)}
      contentClassName={contentClassName}
      isOpen={isOpen}
      onClose={onClose ?? onCancel}
      title={titleText}
      doNotCloseOnOutsideClick={doNotCloseOnOutsideClick}
      titleAdditionalContent={titleAdditionalContent}
    >
      <div className={clsx(styles.text, textClassName)}>
        {children ? children : bodyText}
      </div>
      {!hideButtons && (
        <div
          className={clsx(
            styles.rowContainer,
            styles.justifyContentFlexEnd,
            styles.buttonContainerClearModal,
            styles.columnGap10,
            buttonContainerClassName,
          )}
        >
          {formSubmitErrorText && (
            <div className={clsx(styles.unexpectedServerError, styles.flex1)}>
              {formSubmitErrorText}
            </div>
          )}
          <Button
            testId={cancelButtonTestId}
            title={cancelButtonText}
            onClick={onCancel}
            color={cancelButtonColor}
          />
          <Button
            testId={submitButtonTestId}
            title={submitButtonText}
            onClick={onSubmit}
            color={submitButtonColor}
            loading={isLoading}
            disabled={isDisabled}
          />
        </div>
      )}
    </Modal>
  );
};
